module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyBAMAAABYG2ONAAAAKlBMVEXBAADCBATECwvJICDLKirRRETYYGDddXXqqanttbXvvr7yysr33t7////gcdmwAAAASUlEQVRIx2O4iwXcYMAL6KvllrGxCYlabjIwMI1ULTfS0lIZGBjT0tLOEqvlOpy7dyRqISPERngaIy9XDroSZhSMglEwCkYeAAC7v3RPu8dioQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/to.png
// module id = aUIk
// module chunks = 0